<template>

  
  <img alt="Vue logo" src="./assets/aukss.jpg" 
  style="width:160px; height:160px">
<br/> 
<marquee style="color: darkred"> 
L'Agence Urbaine est à l'écoute des citoyens et
 des usagers et leur souhaite la bienvenue.&nbsp;&nbsp;&nbsp;
الوكالة الحضرية ترحب يالمواطنين وكافة مستعمليها ودائما في الاستماع لهم</marquee>

  <AUKSSComponent/>
</template>

<script>

import AUKSSComponent from './components/AUKSSComponent.vue'

export default {
  name: 'App',
  components: {
  
    AUKSSComponent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
